import { omit } from 'es-toolkit';
import features, { ZRM_API, ZRM_DEV_BRAND } from '../constants/FeatureFlagConstants';
import isProduction from './isProduction';

// JSON.parse converts "true" to boolean true, and "false" to boolean false
// override with query if necessary
const getServices = (cookies: Record<string, string> = {}, query: Record<string, string> = {}) => {
  let availableFeatures: Partial<Record<keyof typeof features, string | boolean>> = features;
  if (isProduction(process.env.ZG_ENV)) {
    availableFeatures = omit(availableFeatures, [ZRM_API, ZRM_DEV_BRAND]);
  }

  return Object.entries(availableFeatures).reduce<Record<string, string | boolean>>((ret, [name, value]) => {
    if (cookies[name]) {
      value = cookies[name];
    }

    if (query[name]) {
      value = query[name];
    }

    try {
      ret[name] = JSON.parse(value as string); // booleans
    } catch (error) {
      ret[name] = value as string; // strings
    }

    return ret;
  }, {});
};

export { getServices };
